import SearchResultsWidgetRequest from '../api/SearchResultsWidgetSearchRequest.js';
export default (rfkId) => {
    const request = new SearchResultsWidgetRequest(rfkId);
    request.setSearchContent({});
    request.setSearchFacetAll(true);
    request.setSearchOffset(0);
    request.setSearchSortChoices(true);
    return request;
};
